import React, { useCallback, useEffect, useMemo,useState } from "react";
import _ from "lodash";
import { Button, Card, Col, Container, Form, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import swal from "sweetalert";
import { inputChange, saveData } from "../helpers";
import { selectTooltip, selectTooltip_en } from "../utils/selectTooltip";
import { useTranslation } from "react-i18next";

const FormProjectGeneralUpdate = (props) => {
    const [t,i18n] = useTranslation("create")
    const { mainData, ddlForm, setMainData, currentProj, davipola ,clients_info } = props;
    const [country, setCountry] = useState("")
    const [departament, setDepartment] = useState("")
    const allProjectsData = useSelector((state) => state.projects.projects);
    const [clients, setClients]= useState({})
    const PARTNER_ID_1 = process.env.REACT_APP_PARTNER_ID_1;
    const PARTNER_ID_2 = process.env.REACT_APP_PARTNER_ID_2;
    const PARTNER_ID_3 = process.env.REACT_APP_PARTNER_ID_3;
    const PARTNER_ID_4 = process.env.REACT_APP_PARTNER_ID_3;

  useEffect(()=>{
    if(!mainData.new){
    searchingForCliente(mainData.IdClienteConsulting)
    }
    
  },[mainData])

  const searchingForCliente = (clienteID)=>{
    const selectClient  = clienteID ? clients_info?.filter(cl => cl.IdClienteConsulting == clienteID)[0] : [{IdClienteConsulting:"",Cod_cliente:"",Nombre_Cliente:"",Nit:""}]
    setClients(selectClient)
  }
    const codExists = useMemo(() => {
      let findProject = allProjectsData.find(
        (project) => project.CODProyecto === mainData.CODProyecto
      );
      if (findProject && currentProj?.CODProyecto !== mainData.CODProyecto) {
        return true;
      }
      return false;
    }, [mainData, currentProj]);
  
    const handleChangeCOD = useCallback(
      (e) => {
        if (!e.target.value) {
          e.target.value = currentProj?.CODProyecto || "";
        }
        inputChange(e, setMainData);
      },
      [currentProj]
    );
  
    let history = useHistory();
  
    useEffect(()=>{
      if(!mainData.new){
        setDepartment(mainData.Departamento)
      }
    },[mainData.Departamento])
  

    const patner_asociate_user = ddlForm.filter( ddl => 
      (ddl.ID == PARTNER_ID_1) || (ddl.ID == PARTNER_ID_2 ) || (ddl.ID == PARTNER_ID_3 ) || (ddl.ID == PARTNER_ID_4 )
    )
    const no_aply = [{ID: null , VALOR:"No Aplica"}]
 
    const patner_asociate = patner_asociate_user.concat(no_aply)

    const onSubmit = (e) => {
        e.preventDefault();
        const success = () => {
          swal(t("project_modal_done_1"), t("project_modal_done_2"), "success").then(() => {
            history.push("/projects");
          });
        };
        saveData("projects", mainData, success);
      };

    const IdOrganizacion = window.localStorage.getItem('OID')

    const fieldsFromLocalStorate = JSON.parse(window.localStorage.getItem('customFields'))
    let viewFields = _.filter(fieldsFromLocalStorate,{'entidad':'Proyectos', 'promocionar': true})
  return (
    <>
    <Container fluid className="py-4" style={{ maxWidth: "1400px" }}>
      <Form onSubmit={onSubmit}>
        {/* =========================
            SECCIÓN 1: DATOS GENERALES
        ========================== */}
        <Card className="shadow-sm mb-4">
          <Card.Header className="bg-light">
            <h5 className="mb-0">
              <i className="fa fa-info-circle text-primary mr-2"></i>
              {t("project_title_generaldata")}
            </h5>
          </Card.Header>
          <Card.Body>
            <Row>
              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label data-tip={(t("create_lenguaje") == "es")? selectTooltip(11): selectTooltip_en(11)}>
                    {t("project_formdata_cod")} <small className="text-danger">*</small>
                  </Form.Label>
                  <Form.Control
                    name="CODProyecto"
                    onChange={handleChangeCOD}
                    value={mainData.CODProyecto || ""}
                    required
                  />
                  {codExists && (
                    <Form.Text className="text-danger">
                      {t("project_formdata_cod_already_exists")}
                    </Form.Text>
                  )}
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label  data-tip={(t("create_lenguaje") == "es")? selectTooltip(12): selectTooltip_en(12)}>
                    {t("project_formdata_name")} <small className="text-danger">*</small>
                  </Form.Label>
                  <Form.Control
                    name="Nombre"
                    onChange={(e) => inputChange(e, setMainData)}
                    value={mainData.Nombre || ""}
                    required
                  />
                </Form.Group>
              </Col>

              <Col md={3}>
                <Form.Group className="mb-3">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://projects.co.pwc.com/testagilidad/test/index.html#/"
                  >
                    <i
                      data-tip={(t("create_lenguaje") == "es")?selectTooltip(32): selectTooltip_en(32)}
                      className="fa fa-question-circle text-info mr-2"
                    ></i>
                  </a>
                  <Form.Label data-tip={(t("create_lenguaje") == "es")? selectTooltip(13) : selectTooltip_en(13)}>
                    {t("project_formdata_methodology")} <small className="text-danger">*</small>
                  </Form.Label>
                  <Form.Control
                    as="select"
                    name="Metodologia"
                    onChange={(e) => inputChange(e, setMainData)}
                    value={mainData.Metodologia || ""}
                    required
                    disabled={mainData.new ? false : true}
                  >
                    <option value="">
                      {t("project_formdata_methodology_select")}...
                    </option>
                    {_.filter(ddlForm, { DDL: "METODOLOGIA" }).map((item) => (
                      <option key={item.ID} value={item.ID}>
                        {item.VALOR}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={mainData.Metodologia == "Tradicional" || mainData.Metodologia  == "Waterfall"? 8 : 12}>
                <Form.Group className="mb-3">
                  <Form.Label data-tip={(t("create_lenguaje") == "es")? selectTooltip(14): selectTooltip_en(14)} >{t("project_formdata_description")}</Form.Label>
                  <Form.Control
                    as="textarea"
                    name="Descripcion"
                    rows="3"
                    onChange={(e) => inputChange(e, setMainData)}
                    value={mainData.Descripcion || ""}
                  />
                </Form.Group>
              </Col>
          { (IdOrganizacion == 'DC4EACD3-39FB-49E8-9D3E-DD58C8038A32' /* || IdOrganizacion == '8CAADED8-A836-4CB3-8822-878440CC4E30' */ ) && 
               <Col md={4}>
                {/* 3.a) Checkbox para activar plantilla */}
                { mainData.Metodologia == "Tradicional" || mainData.Metodologia  == "Waterfall" ? 
                <Form.Group className="mb-3">
                  <Form.Check
                    type="checkbox"
                    label="Usar Plantilla"
                    /* label={t("project_formdata_use_template")}  */
                    name="UseTemplate"
                    disabled={mainData.new ? false : true}
                    checked={!!mainData.UseTemplate}
                    onChange={e => setMainData({
                      ...mainData,
                      UseTemplate: e.target.checked,
                      // si desmarcas, limpias la selección
                      ...(e.target.checked ? {} : { IdPlantilla: '' })
                    })}
                  />
                </Form.Group> :
                <></>
                }
                {/* 3.b) Select de plantillas (solo si está marcado) */}
                {mainData.UseTemplate &&  mainData.Metodologia == "Tradicional" || mainData.Metodologia  == "Waterfall" ?
                  <Form.Group className="mb-3">
                    {/* <Form.Label>{t("project_formdata_select_template")}</Form.Label> */}
                    <Form.Label>Plantillas </Form.Label>
                    <Form.Control
                      as="select"
                      name="IdPlantilla"
                      value={mainData.IdPlantilla}
                      disabled={mainData.new  ? false : true}
                      onChange={(e) => inputChange(e, setMainData)}
                      required
                      style={{ borderColor: '#AD1B02' }}
                    >
                   {/*    <option value="">{t("project_formdata_template_select")}…</option> */}
                   <option value="">Seleccionar Plantilla…</option>
                     {_.filter(ddlForm, { DDL: "PLANTILLAS" }).map((item) => (
                      <option key={item.ID} value={item.ID}>
                        {item.VALOR}
                      </option>
                    ))}
                    </Form.Control>
                  </Form.Group>
                :<></>}
              </Col>}
            </Row>
          </Card.Body>
        </Card>

        {/* =========================
            SECCIÓN 2: CLASIFICACIÓN
        ========================== */}
        { (IdOrganizacion == 'DC4EACD3-39FB-49E8-9D3E-DD58C8038A32' /* || IdOrganizacion == '8CAADED8-A836-4CB3-8822-878440CC4E30'  */) && 
        <Card className="shadow-sm mb-4">
          <Card.Header className="bg-light">
            <h5 className="mb-0">
              <i className="fa fa-tags text-primary mr-2"></i>
              Clasificación
            </h5>
          </Card.Header>
          <Card.Body>
            <Row>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    {t("project_submission_proposal")} <small className="text-danger">*</small>
                  </Form.Label>
                  <Form.Control
                    as="select"
                    name="IdFuente_propuesta"
                    onChange={(e) => inputChange(e, setMainData)}
                    value={mainData.IdFuente_propuesta || ""}
                    required
                  >
                    <option value="">
                      {t("project_formdata_methodology_select")}...
                    </option>
                    {_.orderBy(_.filter(ddlForm, { DDL: "Fuente_propuesta" }),["ID"],["asc"]).map((item) => (
                      <option key={item.ID} value={item.ID}>
                        {item.VALOR}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    {t("project_chain_value")} <small className="text-danger">*</small>
                  </Form.Label>
                  <Form.Control
                    as="select"
                    name="IdCadena"
                    onChange={(e) => {
                      inputChange(e, setMainData)
                    }}
                    value={mainData.IdCadena || ""}
                    required
                  >
                    <option value="">
                      {t("project_formdata_methodology_select")}...
                    </option>
                    {_.orderBy(
                      _.filter(ddlForm, { DDL: "Cadena_valor" }),
                      ["ID"],
                      ["asc"]
                    ).map((item) => (
                      <option key={item.ID} value={item.ID}>
                        {item.VALOR}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    {t("project_cluster")} <small className="text-danger">*</small>
                  </Form.Label>
                  <Form.Control
                    as="select"
                    name="IdCluster"
                    onChange={(e) => inputChange(e, setMainData)}
                    value={mainData.IdCluster || ""}
                    required
                  >
                    <option value="">
                      {t("project_formdata_methodology_select")}...
                    </option>
                    {_.orderBy(_.filter(ddlForm, { DDL: "Cluster" }), ["ID"], ["asc"]).map(
                      (item) => (
                        <option key={item.ID} value={item.ID}>
                          {item.VALOR}
                        </option>
                      )
                    )}
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    {t("project_patner_asociate")} <small className="text-danger">*</small>
                  </Form.Label>
                  <Form.Control
                    as="select"
                    name="IdPatner"
                    onChange={(e) => inputChange(e, setMainData)}
                    value={mainData.IdPatner || ""}
                    required
                  >
                   {/*  <option value="">
                      {t("project_formdata_methodology_select")}...
                    </option> */}
                    {patner_asociate.map((item) => (
                      <option key={item.ID} value={item.ID}>
                        {item.VALOR}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    {t("project_priority")} <small className="text-danger">*</small>
                  </Form.Label>
                  <Form.Control
                    as="select"
                    name="idPrioridad"
                    onChange={(e) => inputChange(e, setMainData)}
                    value={mainData.idPrioridad || ""}
                    required
                    disabled = {mainData.IdCadena == 1 || mainData.IdCadena == 2 ? false : true }
                  >
                    <option value="">
                      {t("project_formdata_methodology_select")}...
                    </option>
                    {_.orderBy(
                      _.filter(ddlForm, { DDL: "Proyecto_prioridad" }),
                      ["ID"],
                      ["asc"]
                    ).map((item) => (
                      <option key={item.ID} value={item.ID}>
                        {item.VALOR}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    {t("project_sector")} <small className="text-danger">*</small>
                  </Form.Label>
                  <Form.Control
                    as="select"
                    name="idSector"
                    onChange={(e) => inputChange(e, setMainData)}
                    value={mainData.idSector || ""}
                    required
                  >
                    <option value="">
                      {t("project_formdata_methodology_select")}...
                    </option>
                    {_.orderBy(_.filter(ddlForm, { DDL: "Proyecto_sector" }),["ID"],
                      ["asc"]).map((item) => (
                      <option key={item.ID} value={item.ID}>
                        {item.VALOR}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>
             <Row>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Cliente <small className="text-danger">*</small>
                  </Form.Label>
                  <Form.Control
                    as="select"
                    name="IdClienteConsulting"
                    onChange={(e) => { 
                      inputChange(e, setMainData)
                      searchingForCliente(e.target.value)
                    }}
                    value={mainData.IdClienteConsulting || ""}
                  >
                    <option value="">
                      {t("project_formdata_methodology_select")}...
                    </option>
                    {_.orderBy(
                      _.filter(ddlForm, { DDL: "Nombre_Cliente" }),
                      ["Nombre_Cliente"],
                      ["asc"]
                    ).map((item) => (
                      <option key={item.ID} value={item.ID}>
                        {item.VALOR}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Código Cliente{/*  <small className="text-danger">*</small> */}
                  </Form.Label>
                  <Form.Control
                    as="select"
                    value={clients?.Cod_cliente || 0}
                    disabled
                  /*   name="idPrioridad" */
                    onChange={(e) => inputChange(e, setMainData)}
               /*      value={mainData.idPrioridad || ""} */
                 /*    disabled = {mainData.IdCadena == 1 || mainData.IdCadena == 2 ? false : true } */
                  >
                    <option value="">
                      {clients?.Cod_cliente || 0}
                    </option>
{/*                     
                    {_.orderBy(
                      _.filter(ddlForm, { DDL: "Proyecto_prioridad" }),
                      ["ID"],
                      ["asc"]
                    ).map((item) => (
                      <option key={item.ID} value={item.ID}>
                        {item.VALOR}
                      </option>
                    ))} */}
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    NIT 
                  </Form.Label>
                  <Form.Control
                    as="select"
                   /*  value={clients.Nit || "0000000"} */
                   /*  name="idSector" */
                    onChange={(e) => inputChange(e, setMainData)}
               /*      value={mainData.idSector || ""} */
               /*      required */
                    disabled
                  >
                      <option value="">
                      {clients?.Nit || 0}
                    </option>
{/*                     <option value="">
                      {t("project_formdata_methodology_select")}...
                    </option>
                    {_.filter(ddlForm, { DDL: "Proyecto_sector" }).map((item) => (
                      <option key={item.ID} value={item.ID}>
                        {item.VALOR}
                      </option>
                    ))} */}
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>
          </Card.Body>
        </Card>
        }

        {/* =========================
            SECCIÓN 3: UBICACIÓN
        ========================== */}
        <Card className="shadow-sm mb-4">
          <Card.Header className="bg-light">
            <h5 className="mb-0">
              <i className="fa fa-users-cog text-primary mr-2"></i>
              Tipología y Responsable
            </h5>
          </Card.Header>
          <Card.Body>
            <Row>
              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label data-tip={(t("create_lenguaje") == "es")? selectTooltip(15): selectTooltip_en(15)}>
                    {t("project_formdata_type")} <small className="text-danger">*</small>
                  </Form.Label>
                  <Form.Control
                    as="select"
                    name="IdTipoProyecto"
                    onChange={(e) => inputChange(e, setMainData)}
                    value={mainData.IdTipoProyecto || ""}
                    required
                  >
                    <option value="">
                      {t("project_formdata_methodology_select")}...
                    </option>
                    {_.filter(ddlForm, { DDL: "TIPO_PROYECTO" }).map((item) => (
                      <option key={item.ID} value={item.ID}>
                        {item.VALOR}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>

              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label data-tip={(t("create_lenguaje") == "es")? selectTooltip(17): selectTooltip_en(17)}>
                    {mainData.Metodologia === "Ágil"
                      ? "Product Owner"
                      : t("project_formdata_manager")}
                    <small className="text-danger">*</small>
                  </Form.Label>
                  <Form.Control
                    as="select"
                    name="Gerente"
                    onChange={(e) => inputChange(e, setMainData)}
                    value={mainData.Gerente || ""}
                    required
                  >
                    <option value="">
                      {t("project_formdata_methodology_select")}...
                    </option>
                    {_.filter(ddlForm, { DDL: "USUARIOS" }).map((item) => (
                      <option key={item.ID} value={item.ID}>
                        {item.VALOR}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>

              {/* Campos adicionales si la metodología es Ágil */}
              {mainData.Metodologia === "Ágil" && (
                <>
                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label data-tip={(t("create_lenguaje") == "es")? selectTooltip(33): selectTooltip_en(33)}>
                        Scrum Master <small className="text-danger">*</small>
                      </Form.Label>
                      <Form.Control
                        as="select"
                        name="ScrumMaster"
                        onChange={(e) => inputChange(e, setMainData)}
                        value={mainData.ScrumMaster || ""}
                        required
                      >
                        <option value="">
                          {t("project_formdata_methodology_select")}...
                        </option>
                        {_.filter(ddlForm, { DDL: "USUARIOS" }).map((item) => (
                          <option key={item.ID} value={item.ID}>
                            {item.VALOR}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>
                  </Col>

                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        {t("project_formdata_money")}
                        <small className="text-danger">*</small>
                      </Form.Label>
                      <Form.Control
                        as="select"
                        name="IdCostosAgil"
                        onChange={(e) => inputChange(e, setMainData)}
                        value={mainData.IdCostosAgil || ""}
                        required
                      >
                        <option value="">
                          {t("project_formdata_methodology_select")}...
                        </option>
                        {_.filter(ddlForm, { DDL: "COSTOSAGIL" }).map((item) => (
                          <option key={item.ID} value={item.ID}>
                            {item.VALOR}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>
                  </Col>

                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        {t("project_formdata_duration")}
                        <small className="text-danger">*</small>
                      </Form.Label>
                      <Form.Control
                        as="select"
                        name="DuracionAgil"
                        onChange={(e) => inputChange(e, setMainData)}
                        value={mainData.DuracionAgil || ""}
                        required
                      >
                        <option value="">
                          {t("project_formdata_methodology_select")}...
                        </option>
                        {_.filter(ddlForm, { DDL: "DURATIONAGIL" }).map((item) => (
                          <option key={item.ID} value={item.ID}>
                            {item.VALOR}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>
                  </Col>
                </>
              )}

              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label data-tip={(t("create_lenguaje") == "es")? selectTooltip(16): selectTooltip_en(16)}>
                    {t("project_formdata_country")} <small className="text-danger">*</small>
                  </Form.Label>
                  <Form.Control
                    as="select"
                    name="IdPais"
                    onChange={(e) => {
                      if (e.target.value === "1") {
                        setCountry("COL");
                      } else {
                        setCountry("");
                      }
                      inputChange(e, setMainData);
                    }}
                    value={mainData.IdPais || ""}
                    required
                  >
                    <option value="">
                      {t("project_formdata_methodology_select")}...
                    </option>
                    {_.filter(ddlForm, { DDL: "PAIS" }).map((item) => (
                      <option key={item.ID} value={item.ID}>
                        {item.VALOR}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>

              {/* Si es Colombia, mostramos Departamento y Municipio */}
              {(country === "COL" || mainData.IdPais == 1) && (
                <>
                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>Departamento</Form.Label>
                      <Form.Control
                        as="select"
                        name="Departamento"
                        onChange={(e) => {
                          setDepartment(e.target.value);
                          inputChange(e, setMainData);
                        }}
                        value={mainData.Departamento || ""}
                      >
                        <option value="">
                          {t("project_formdata_methodology_select")}...
                        </option>
                        {_.filter(davipola, { Entidad: "Departamento" }).map((item) => (
                          <option key={item.Id_Espacial} value={item.Departamento}>
                            {item.Departamento}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>Municipio</Form.Label>
                      <Form.Control
                        as="select"
                        name="Municipio"
                        onChange={(e) => inputChange(e, setMainData)}
                        value={mainData.Municipio || ""}
                      >
                        <option value="">
                          {t("project_formdata_methodology_select")}...
                        </option>
                        {_.filter(davipola, { Departamento: departament }).map((item) => (
                          <option key={item.Id_Espacial} value={item.Municipio}>
                            {item.Municipio}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>
                  </Col>
                </>
              )}
            </Row>
          </Card.Body>
        </Card>

        {/* =========================
            SECCIÓN 4: PERFIL DEL PROYECTO
        ========================== */}
        <Card className="shadow-sm mb-4">
          <Card.Header className="bg-light">
            <h5 className="mb-0">
              <i className="fa fa-book text-primary mr-2"></i>
              {t("project_title_projectprofile")}
            </h5>
          </Card.Header>
          <Card.Body>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label data-tip={(t("create_lenguaje") == "es")? selectTooltip(18) : selectTooltip_en(18)}>{t("project_formdata_justification")}</Form.Label>
                  <Form.Control
                    as="textarea"
                    name="Justificacion"
                    rows="3"
                    onChange={(e) => inputChange(e, setMainData)}
                    value={mainData.Justificacion || ""}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label data-tip={(t("create_lenguaje") == "es")? selectTooltip(19): selectTooltip_en(19)}>{t("project_formdata_antecedents")}</Form.Label>
                  <Form.Control
                    as="textarea"
                    name="Antecedentes"
                    rows="3"
                    onChange={(e) => inputChange(e, setMainData)}
                    value={mainData.Antecedentes || ""}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label data-tip={(t("create_lenguaje") == "es")? selectTooltip(20): selectTooltip_en(20)}>{t("project_formdata_generalobjective")}</Form.Label>
                  <Form.Control
                    as="textarea"
                    name="ObjGeneral"
                    rows="3"
                    onChange={(e) => inputChange(e, setMainData)}
                    value={mainData.ObjGeneral || ""}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label data-tip={(t("create_lenguaje") == "es")? selectTooltip(21) : selectTooltip_en(21)}>{t("project_formdata_specificobjectives")}</Form.Label>
                  <Form.Control
                    as="textarea"
                    name="ObjEspecificos"
                    rows="3"
                    onChange={(e) => inputChange(e, setMainData)}
                    value={mainData.ObjEspecificos || ""}
                  />
                </Form.Group>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        {/* BOTÓN DE GUARDAR (fuera de las Cards) */}
        <div className="text-right">
          <Button variant="success" type="submit" className="shadow">
            <i className="fa fa-save mr-2"></i>
            {t("project_button_save")}
          </Button>
        </div>
      </Form>
    </Container>
    </>
  )
}

export default FormProjectGeneralUpdate
